import { __assign, __awaiter, __generator } from "tslib";
import { apiService } from "../configs/api";
/** @from pcp-client */
export var callAPI = function (requestConfig) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, apiService(__assign(__assign({}, requestConfig), { cache: requestConfig.cache
                    ? { methods: [requestConfig.method] }
                    : false }))];
    });
}); };
